import { useContext } from 'react';
import { WindowDimensionsContext } from '../context/WindowDimensionsContext';
export function useWindowDimensionsContext() {
  return useContext(WindowDimensionsContext);
}